"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_common_components_1 = require("@desygner/ui-common-components");
const ui_common_translation_1 = require("@desygner/ui-common-translation");
const Link_styles_1 = require("./Link.styles");
var LinkType;
(function (LinkType) {
    LinkType["url"] = "URL";
    LinkType["email"] = "Email";
    LinkType["phone"] = "Phone";
})(LinkType || (LinkType = {}));
const linkPrefix = {
    'https://': LinkType.url,
    'http://': LinkType.url,
    'mailto:': LinkType.email,
    'tel:': LinkType.phone,
    '#': 'page',
};
function Link({ initialValue = '', isLinked = false, onUpdate, numberOfPages = 1, linkTypePlaceholder, }) {
    const [options, setOptions] = (0, react_1.useState)(LinkType.url);
    const [type, setType] = (0, react_1.useState)('link');
    const [value, setValue] = (0, react_1.useState)(initialValue);
    const [isEditing, setIsEditing] = (0, react_1.useState)(false);
    const [isElementLinked, setElementLinked] = (0, react_1.useState)(isLinked);
    const theme = (0, ui_common_components_1.useTheme)();
    const { t } = (0, ui_common_translation_1.useTranslation)();
    const handleLink = (0, react_1.useCallback)((isLinked, value) => {
        if (!isLinked) {
            setValue('');
            onUpdate({ action: 'on_unlinkElement', data: {} });
            setElementLinked(false);
        }
        else {
            const linkType = type === 'link' ? options : type;
            setValue(value);
            onUpdate({ data: { type: linkType, value, isEditing } });
            setElementLinked(true);
            setIsEditing(false);
        }
    }, [onUpdate, isEditing, options, type]);
    const handleChangeLinkType = (0, react_1.useCallback)((type) => {
        setOptions(type);
        setValue('');
    }, []);
    // These effects are required because ant-dropdown is not unmounting the component
    (0, react_1.useEffect)(function updateInitialValue() {
        const value = initialValue;
        const prefixesRegex = /^(?:https:\/\/|http:\/\/|mailto:|tel:|#)/;
        const match = initialValue.match(prefixesRegex);
        setValue(value.replace(prefixesRegex, ''));
        if (!match)
            return;
        const prefixType = linkPrefix[match[0]];
        if (prefixType === 'page') {
            setType('page');
        }
        else {
            setType('link');
            setOptions(prefixType);
        }
    }, [initialValue]);
    (0, react_1.useEffect)(function updateIsLinked() {
        setElementLinked(isLinked);
    }, [isLinked]);
    const pageOptions = (0, react_1.useMemo)(() => {
        return Array.from({ length: numberOfPages }, (_, index) => ((0, jsx_runtime_1.jsx)("option", { value: index + 1, children: index + 1 }, `page-${index}`)));
    }, [numberOfPages]);
    const linkOptions = [
        { value: LinkType.url, label: LinkType.url },
        { value: LinkType.email, label: LinkType.email },
        { value: LinkType.phone, label: LinkType.phone },
    ];
    return (
    // TODO: Change StyledContainer from Form to Div after using custom Select component
    (0, jsx_runtime_1.jsxs)(Link_styles_1.StyledContainer, { onSubmit: (event) => event.preventDefault(), children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Radio, { label: t('general.link'), name: "link", onClick: () => {
                    setType('link');
                    setValue('');
                }, checked: type === 'link', disabled: !isEditing && isElementLinked }), (0, jsx_runtime_1.jsxs)(Link_styles_1.StyledInput, { children: [(0, jsx_runtime_1.jsxs)(Link_styles_1.StyledSelectContainer, { children: [(0, jsx_runtime_1.jsx)(Link_styles_1.StyledSelect, { onChange: (event) => handleChangeLinkType(event.target.value), disabled: type === 'page' || (!isEditing && isElementLinked), children: linkOptions.map((option) => ((0, jsx_runtime_1.jsx)("option", { value: option.value, children: option.label }, option.value))) }), (0, jsx_runtime_1.jsx)(Link_styles_1.StyledIconSelect, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: "chevron---20", size: "Small", color: theme.Color.Neutrals.Dark }) })] }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Input, { id: "link-input", name: "link-input", value: type === 'link' ? value : '', onChange: (value) => setValue(value), disabled: type === 'page' || (isElementLinked && !isEditing), placeholder: linkTypePlaceholder[options.toLowerCase()] })] }), numberOfPages > 1 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Radio, { label: t('popupmenu.link.page_link'), name: "link", checked: type === 'page', onClick: () => {
                            setType('page');
                            setValue(`${pageOptions[0].props.value}`);
                        }, disabled: !isEditing && isElementLinked }), (0, jsx_runtime_1.jsxs)(Link_styles_1.StyledSelectContainer, { children: [(0, jsx_runtime_1.jsx)(Link_styles_1.StyledSelect, { onChange: (event) => setValue(event.target.value), disabled: type === 'link', value: type === 'page' ? value : pageOptions[0].props.value, children: pageOptions }), (0, jsx_runtime_1.jsx)(Link_styles_1.StyledIconSelect, { children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Icon, { name: "chevron---20", size: "Small", color: theme.Color.Neutrals.Dark }) })] })] })), (!isElementLinked || isEditing) && ((0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "primary", onClick: () => handleLink(true, value), label: t('general.apply'), size: "Small", disabled: value === '' })), isElementLinked && !isEditing && ((0, jsx_runtime_1.jsxs)(Link_styles_1.StyledLinkedWrapper, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "outline", onClick: () => setIsEditing(true), label: t('popupmenu.tooltip.edit'), color: theme.Components.Panel.Background, size: "Medium" }), (0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "custom", onClick: () => handleLink(false, ''), label: t('popupmenu.tooltip.remove'), size: "Medium", textColor: theme.Color.NeutralsFixed.Light, color: theme.Color.Feedback.Alert })] }))] }));
}
exports.Link = Link;
//# sourceMappingURL=Link.js.map